import { useEffect, useState } from "react";
import { useTheme } from "next-themes";

import { Moon, Sun } from "../icons";
import { useDraggableFloating } from "../../hooks/use-draggable-floating";
import {
  FLOATING_LAUNCHER_CLASS,
  FLOATING_LAUNCHER_ICON_CLASS,
  FLOATING_LAUNCHER_STACK,
} from "../floating-launcher";
import { Button } from "../ui/button";

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  const { ref, style, isDragging, dragHandlers } = useDraggableFloating(
    "sparelynk-theme-toggle-position",
    { id: "theme", stackIndex: FLOATING_LAUNCHER_STACK.theme },
  );

  useEffect(() => {
    setMounted(true);
  }, []);

  const isDark = mounted && resolvedTheme === "dark";
  const nextTheme = isDark ? "light" : "dark";

  return (
    <Button
      ref={ref}
      type="button"
      size="icon"
      variant="default"
      data-dragging={isDragging}
      className={FLOATING_LAUNCHER_CLASS}
      style={style}
      {...dragHandlers}
      onClick={() => setTheme(nextTheme)}
      aria-label={mounted ? `Switch to ${nextTheme} theme` : "Toggle theme"}
      title={mounted ? `Switch to ${nextTheme} theme` : "Toggle theme"}
    >
      {isDark ? (
        <Moon className={FLOATING_LAUNCHER_ICON_CLASS} aria-hidden="true" />
      ) : (
        <Sun className={FLOATING_LAUNCHER_ICON_CLASS} aria-hidden="true" />
      )}
    </Button>
  );
}
